export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_q02_a.4b6a9af2.png";